import { render, staticRenderFns } from "./SettingsLanguage.vue?vue&type=template&id=49f083ea"
import script from "./SettingsLanguage.vue?vue&type=script&lang=js"
export * from "./SettingsLanguage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports